import LettuceChefImage from '../images/lettuce-chef.png'
import AppetizerImage from '../images/appetizer.png';
import VeganAppetizerImage from '../images/appetizer-vegan.png';
import SpeechBubble from './SpeechBubble';
import { useState } from "react";

function AppetizerLoading() {
  const [isVegan, setIsVegan] = useState(false);

  return (
    <div className="flex flex-col justify-center items-center pt-24 pb-12 max-w-md mx-auto">
      <img
        src={LettuceChefImage}
        alt="Appetizer"
        className="max-w-48 ml-12"
      />
      <SpeechBubble
        header="Cooking Up Your Custom Deck!"
        subtitle="One moment while we create a custom deck for your family! This may take a few minutes. Please enjoy this complimentary appetizer while you wait."
      />

      <span>Cooking your deck...</span>
      <div className="loading loading-spinner loading-lg mt-2"></div>

      <div className="flex flex-col items-center gap-4">
        <button
          className="btn mt-4 btn-primary btn-sm"
          onClick={() => setIsVegan((v) => !v)}
        >
          {isVegan ? "Prefer non-vegan option?" : "Are you vegan?"}
        </button>
        <img
          src={isVegan ? VeganAppetizerImage : AppetizerImage}
          alt={isVegan ? "Vegan appetizer" : "Non-vegan appetizer"}
          className="max-w-lg mb-4"
        />
      </div>
    </div>
  );
}

export default AppetizerLoading;